"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const clock_1 = __importDefault(require("./clock"));
const ExpirationTimer = ({ expirationDate, onExpiration, transparent, expired }) => {
    const [stopped, setStopped] = (0, react_1.useState)(false);
    const onTimeOut = () => {
        setStopped(true);
    };
    const onCartSync = () => {
        setStopped(false);
    };
    const getExpiredCart = () => {
        onExpiration && onExpiration().then(() => onCartSync);
    };
    (0, react_1.useEffect)(() => {
        if (stopped)
            getExpiredCart();
    }, [stopped]);
    (0, react_1.useEffect)(() => {
        setStopped(false);
    }, [expirationDate]);
    if (!expirationDate && !expired)
        return null;
    return ((0, jsx_runtime_1.jsx)(clock_1.default, { onTimeOut: onTimeOut, expirationDate: expirationDate, stopped: stopped, transparent: transparent, expired: expired }));
};
exports.default = ExpirationTimer;
